import script from "./EditCompanyEmailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditCompanyEmailModal.vue?vue&type=script&setup=true&lang=js"

import "./EditCompanyEmailModal.vue?vue&type=style&index=0&id=4cd4fc27&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cd4fc27"]])

export default __exports__